import { create } from "zustand";
import { toast } from "sonner";

type AuthState = {
  userId: string | null;
  roles: string[];
  /** True after Auth0TokenBridge has applied a session snapshot (authed or not). */
  isRolesLoaded: boolean;
  isAuthenticated: boolean;
  radiologist_id: number | null;
};

type AuthActions = {
  setAuth0Session: (data: {
    userId: string;
    roles: string[];
    radiologistId: number | null;
  }) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState & AuthActions>((set) => ({
  userId: null,
  roles: [],
  isRolesLoaded: false,
  isAuthenticated: false,
  radiologist_id: null,

  setAuth0Session({ userId, roles, radiologistId }) {
    const authed = userId.length > 0;

    set((state) => {
      if (authed) {
        return {
          userId,
          roles,
          isRolesLoaded: true,
          isAuthenticated: true,
          radiologist_id: radiologistId,
        };
      }
      if (!state.isAuthenticated && state.userId === null) {
        if (state.isRolesLoaded) return state;
        return { ...state, isRolesLoaded: true };
      }
      return {
        userId: null,
        roles: [],
        isRolesLoaded: true,
        isAuthenticated: false,
        radiologist_id: null,
      };
    });
  },

  logout() {
    set({
      userId: null,
      roles: [],
      isRolesLoaded: true,
      isAuthenticated: false,
      radiologist_id: null,
    });
    toast.success("Logged out successfully!");
  },
}));
